import { render, staticRenderFns } from "./examine-list.vue?vue&type=template&id=2974c2e2&scoped=true&"
import script from "./examine-list.vue?vue&type=script&lang=js&"
export * from "./examine-list.vue?vue&type=script&lang=js&"
import style0 from "./examine-list.vue?vue&type=style&index=0&id=2974c2e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974c2e2",
  null
  
)

export default component.exports